import { useState } from "react";
import { formatKr } from "../../lib/format";
import CustomerPanel from "../CustomerPanel";

export default function StatsTop({ top }) {
  const [panel, setPanel] = useState(null);
  const max = Math.max(1, ...top.map((x) => x.v));
  return (
    <section className="panel" data-testid="stats-top-customers">
      <h2>Bedste kunder</h2>
      {!top.length ? (
        <p className="st-empty small" data-testid="stats-top-empty">Ingen afhentninger i perioden endnu</p>
      ) : (
        <ol className="st-top">
          {top.map((x, i) => (
            <li key={x.cid} data-testid={`stats-top-row-${i}`}>
              <span className="st-vrank">{i + 1}</span>
              <span className="st-top-main">
                <button type="button" className="linkish" onClick={() => setPanel(x.cid)} data-testid={`stats-top-name-${x.cid}`}>
                  {x.name || "Ukendt kunde"}
                </button>
                <span className="st-bar"><i style={{ width: `${(100 * x.v) / max}%` }} /></span>
              </span>
              <span className="st-vnum"><b>{x.n}</b><small>afhentn.</small></span>
              <span className="st-vnum"><b>{x.q}</b><small>stk.</small></span>
              <span className="st-vnum"><b>{formatKr(x.v)}</b><small>beløb</small></span>
            </li>
          ))}
        </ol>
      )}
      {panel && <CustomerPanel cid={panel} onClose={() => setPanel(null)} onChanged={() => {}} />}
    </section>
  );
}
